export default "__VITE_ASSET__y$7n$XT5__"